"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualCarCoverDetailsWidget = void 0;
var React = require("react");
var moment = require("moment");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var AnnualCarCoverDetailsWidget = exports.AnnualCarCoverDetailsWidget = /** @class */ (function (_super) {
    __extends(AnnualCarCoverDetailsWidget, _super);
    function AnnualCarCoverDetailsWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.navigateToChangeYourCoverLevel = function () {
            window.location.assign("/journey/init/product/AnnualMotorInsurance/process/mtaEditCoverLevel/presetPage/".concat(_this.props.interaction.uistate.relativeInteractionId));
        };
        _this.state = {
            coverStartDate: null
        };
        return _this;
    }
    AnnualCarCoverDetailsWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getPolicies(undefined, services_1.EnumPolicyFilter.NOT_ENDED)
            .subscribe(function (policies) {
            var wolfPolicies = policies.filter(function (policy) { return policy.products.includes(services_1.ProductsEnum.WOLF_MOTOR); }).sort(function (a, b) { return moment(b.endDate).diff(a.endDate); });
            if (wolfPolicies) {
                var agreementVersionIds = wolfPolicies[0].policyHistoryList
                    .filter(function (ph) { return ph.status !== services_1.POLICY_STATUS_MTC; })
                    .map(function (ph) { return ph.id; });
                _this.customerPortalService.getCombinedInstalmentsInfo(agreementVersionIds)
                    .subscribe(function (instalmentsInfo) {
                    _this.setState({ instalmentsInfo: instalmentsInfo });
                });
            }
            _this.setState({
                coverStartDate: wolfPolicies[0].startDate
            });
        });
    };
    AnnualCarCoverDetailsWidget.prototype.render = function () {
        var _a;
        var premiumType = this.props.interaction.factors.premiumType;
        var price = premiumType === services_1.PREMIUM_TYPE_ANNUAL ? this.props.interaction.factors.annualPremium : this.getInstallmentPayment();
        var totalPayableAmount = ((_a = this.state.instalmentsInfo) === null || _a === void 0 ? void 0 : _a.totalAmount) || 0;
        var coverLevel = (0, commonFunctions_1.getCoverTierWording)(this.props.interaction.coverTier);
        var dataLoaded = [premiumType, price, totalPayableAmount, coverLevel].every(function (value) { return value !== undefined; });
        if (dataLoaded) {
            return (React.createElement("div", { className: "text-center annual-car-cover-details-widget" },
                React.createElement("div", { className: "detail amount-detail" },
                    React.createElement("div", { className: "detail-value price fs-18" },
                        React.createElement("span", { className: "price-label" }, premiumType === services_1.PREMIUM_TYPE_ANNUAL ? "Annual price" : "Price"),
                        React.createElement("div", null,
                            React.createElement("span", { className: "amount" }, "".concat((0, commonFunctions_1.getAmountToDisplay)(price))),
                            React.createElement("span", { className: "premium-type" },
                                " / ", " ".concat(premiumType === services_1.PREMIUM_TYPE_ANNUAL ? "year" : "month")))),
                    premiumType === services_1.PREMIUM_TYPE_MONTHLY &&
                        React.createElement("div", { className: "detail-key font-weight-extra-light" },
                            React.createElement("span", null,
                                "You pay ",
                                React.createElement("strong", null, (0, commonFunctions_1.getAmountToDisplay)(totalPayableAmount)),
                                " in total"),
                            ' ',
                            "incl. APR and Insurance Premium Tax")),
                React.createElement("div", { className: "detail pt-3" },
                    React.createElement("div", { className: "detail-key" }, "Cover start date:"),
                    React.createElement("div", { className: "detail-value font-weight-extra-light", id: "vehicle-startDate" }, moment.utc(this.state.coverStartDate, moment.ISO_8601).format("DD MMM YYYY"))),
                React.createElement("div", { className: "detail pt-3" },
                    React.createElement("div", { className: "detail-key" }, "Cover expiry date:"),
                    React.createElement("div", { className: "detail-value font-weight-extra-light", id: "vehicle0-endDate" },
                        moment.utc(this.props.interaction.headerInfo.endDate, moment.ISO_8601).format("DD MMM YYYY"),
                        ", 23:59")),
                React.createElement("div", { className: "detail pt-3" },
                    React.createElement("div", { className: "detail-key" }, "Cover type:"),
                    React.createElement("div", { className: "detail-value font-weight-extra-light" }, "Comprehensive")),
                React.createElement("div", { className: "detail pt-3" },
                    React.createElement("div", { className: "detail-key" }, "Cover level:"),
                    React.createElement("div", { className: "detail-value font-weight-extra-light" }, coverLevel),
                    React.createElement("button", { type: "button", className: "btn btn-white plugin mt-3 mb-0", onClick: this.navigateToChangeYourCoverLevel }, "Change your cover level"))));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    AnnualCarCoverDetailsWidget.prototype.getInstallmentPayment = function () {
        var _a, _b, _c;
        return ((_a = this.state.instalmentsInfo) === null || _a === void 0 ? void 0 : _a.instalments) && ((_b = this.state.instalmentsInfo) === null || _b === void 0 ? void 0 : _b.instalments.length) > 1 ? (_c = this.state.instalmentsInfo) === null || _c === void 0 ? void 0 : _c.instalments[1].amount : 0;
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], AnnualCarCoverDetailsWidget.prototype, "customerPortalService", void 0);
    return AnnualCarCoverDetailsWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AnnualCarCoverDetailsWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/AnnualCarCoverDetailsWidget.js
// module id = 3202
// module chunks = 0